// hooks/usePageTracking.js
"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
const SESSION_KEY = "visitor_session_id";
const HEARTBEAT_INTERVAL_MS = 25000; // ~25s, comfortably under the 5-min "live" window on the backend

function getOrCreateSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}
function detectDeviceType() {
  if (typeof window === "undefined") return null;
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

/**
 * Extracts a clean browser name from the raw user-agent string, instead
 * of sending the full UA (which produces dozens of near-duplicate labels
 * in a breakdown chart — every OS/version combo is a unique string).
 * Order matters: many UAs contain multiple substrings (e.g. Chrome's UA
 * also contains "Safari", Edge's contains both "Chrome" and "Safari"),
 * so the more specific/newer browsers must be checked first.
 */
function getBrowserName(userAgent) {
  if (!userAgent) return "Unknown";
  if (userAgent.includes("Edg/")) return "Edge";
  if (userAgent.includes("OPR/") || userAgent.includes("Opera")) return "Opera";
  if (userAgent.includes("SamsungBrowser")) return "Samsung Internet";
  if (userAgent.includes("Firefox")) return "Firefox";
  if (userAgent.includes("Chrome")) return "Chrome";
  if (userAgent.includes("Safari")) return "Safari";
  return "Other";
}
export function usePageTracking() {
  const $ = _c(6);
  const pathname = usePathname();
  const heartbeatRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      const sessionId = getOrCreateSessionId();
      fetch("/api/track/pageview", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          session_id: sessionId,
          path: pathname,
          referrer: document.referrer || null,
          device_type: detectDeviceType(),
          browser: getBrowserName(navigator.userAgent)
        }),
        keepalive: true
      }).catch(_temp);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== pathname) {
    t2 = () => {
      const sessionId_0 = getOrCreateSessionId();
      const sendHeartbeat = function sendHeartbeat() {
        if (document.visibilityState !== "visible") {
          return;
        }
        fetch("/api/track/heartbeat", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            session_id: sessionId_0,
            path: pathname
          }),
          keepalive: true
        }).catch(_temp2);
      };
      heartbeatRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
      return () => clearInterval(heartbeatRef.current);
    };
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
}
function _temp2() {}
function _temp() {}